import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { convertToNumber } from "./utils/convertToNumber";

export function stackedBarLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;
  const lockedYMin =
    locks?.yMin?.type === DataEnum.Reset ? undefined : locks?.yMin?.value;
  const lockedYMax =
    locks?.yMax?.type === DataEnum.Reset ? undefined : locks?.yMax?.value;
  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset ? undefined : locks?.xMin?.value;
  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset ? undefined : locks?.xMax?.value;

  return {
    lockedXMin: convertToNumber(lockedXMin),
    lockedXMax: convertToNumber(lockedXMax),
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax)
  };
}
